import React from 'react';
import { createRoot } from 'react-dom/client';
//@import 'abort-controller/dist/abort-controller.umd.js';
import App from './App';

const container = document.getElementById('root');
const root = createRoot(container); 
root.render(<App/>);